import constants from '@/constants'
import NewsAPI from '@/modules/news/api/news'

export default {
  updateNews({ commit }) {
    return NewsAPI.getNews().then(({ data }) => {
      const keyedNews = {}
      data.forEach((newsEntry) => {
        keyedNews[newsEntry.id] = newsEntry
        commit('likes/setLikesIt', {
          foreignType: constants.LIKES.TYPE_NEWS,
          foreignId: newsEntry.id,
          likesIt: newsEntry.likes_it,
        }, {
          root: true,
        })
      })
      commit('setAllNews', keyedNews)
    })
  },
  findNewsEntry({ commit, state }, id) {
    return NewsAPI.findNewsEntry(id).then((data) => {
      // Optimistically mark the news as read by the user.
      // This is done for the ask keelearning sidebar to update without reload.
      const currentTime = new Date().toISOString()
      data.user_viewed_at = currentTime

      // We also need to update our list view of news.
      const allNews = { ...state.news }
      if (allNews[id]) {
        allNews[id].user_viewed_at = currentTime
        commit('setAllNews', allNews)
      }

      commit('setNewsEntry', data)
    })
  },
}
